<template>
    <div class="tree-select">
        <el-select
            v-model="selectedLabel"
            :placeholder="placeholder"
            :clearable="clearable"
            @clear="handleClear"
            @focus="handleFocus"
            style="width: 100%"
        >
            <el-option
                :value="selectedValue"
                :label="selectedLabel"
                style="height: auto; padding: 0"
            >
                <div style="padding: 0">
                    <el-tree
                        ref="tree"
                        :data="data"
                        :props="props"
                        :node-key="nodeKey"
                        :default-expand-all="defaultExpandAll"
                        :highlight-current="true"
                        :expand-on-click-node="false"
                        @node-click="handleNodeClick"
                        :check-strictly="checkStrictly"
                        v-if="showTree"
                    >
                    </el-tree>
                </div>
            </el-option>
        </el-select>
    </div>
</template>

<script>
export default {
    name: 'TreeSelect',
    props: {
        value: [String, Number, Array],
        data: {
            type: Array,
            default: () => []
        },
        props: {
            type: Object,
            default: () => ({
                children: 'children',
                label: 'label',
                value: 'value'
            })
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        clearable: {
            type: Boolean,
            default: true
        },
        nodeKey: {
            type: String,
            default: 'id'
        },
        defaultExpandAll: {
            type: Boolean,
            default: false
        },
        checkStrictly: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            selectedValue: this.value,
            selectedLabel: '',
            showTree: false
        }
    },
    watch: {
        value(newVal) {
            this.selectedValue = newVal
            this.updateLabel()
        },
        data: {
            handler() {
                this.updateLabel()
            },
            deep: true
        }
    },
    mounted() {
        this.updateLabel()
    },
    methods: {
        // 更新显示的标签
        updateLabel() {
            if (!this.selectedValue) {
                this.selectedLabel = ''
                return
            }

            const node = this.findNode(this.data, this.selectedValue)
            if (node) {
                this.selectedLabel = node[this.props.label] || ''
            }
        },

        // 递归查找节点
        findNode(data, value) {
            for (let item of data) {
                if (item[this.props.value] === value) {
                    return item
                }
                if (item[this.props.children] && item[this.props.children].length > 0) {
                    const found = this.findNode(item[this.props.children], value)
                    if (found) return found
                }
            }
            return null
        },

        // 节点点击事件
        handleNodeClick(data, node) {
            this.selectedValue = data[this.props.value]
            this.selectedLabel = data[this.props.label]
            this.showTree = false
            this.$emit('input', this.selectedValue)
            this.$emit('change', this.selectedValue, data, node)
        },

        // 清空选择
        handleClear() {
            this.selectedValue = ''
            this.selectedLabel = ''
            this.$emit('input', '')
            this.$emit('change', '')
        },

        // 获取焦点时显示树
        handleFocus() {
            this.showTree = true
            this.$nextTick(() => {
                if (this.selectedValue && this.$refs.tree) {
                    this.$refs.tree.setCurrentKey(this.selectedValue)
                }
            })
        }
    }
}
</script>

<style scoped>
.tree-select ::v-deep .el-select-dropdown__item {
    padding: 0;
    height: auto;
    overflow: visible;
}

.tree-select ::v-deep .el-tree {
    padding: 5px;
    max-height: 300px;
    overflow-y: auto;
}
</style>
